import React from 'react';
import clsx from 'clsx';
import styles from './ProgressDots.module.scss';

type ProgressDotsProps = {
  size?: number,
  active?: number,
}

function ProgressDots({ size = 1, active = 0 }: ProgressDotsProps) {
  const items = Array(size).fill('').map((_, i) => i)

  return (
    <div className={styles.container}>
      {items.map((idx) => (
        <div
          key={idx}
          className={clsx(styles.container, styles.item, (idx === active) && styles.active)}
        />
      ))}
    </div>
  )
}

export default ProgressDots
